import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import MoneyEUIframeCheckout from './MoneyEUIframeCheckout';
import { isAllowedCheckoutUrl, toEmbeddableCheckoutUrl } from './checkoutEmbed';
import './CheckoutEmbedPreview.css';

const CheckoutEmbedPreview: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [activeUrl, setActiveUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fromQuery = searchParams.get('checkoutUrl')?.trim() || '';
    if (!fromQuery) {
      setError('Missing checkout link.');
      return;
    }

    const embeddable = toEmbeddableCheckoutUrl(fromQuery);
    if (!isAllowedCheckoutUrl(embeddable)) {
      setError('Only a MoneyEU hosted checkout URL can be embedded.');
      return;
    }

    setError('');
    setActiveUrl(embeddable);
  }, [searchParams]);

  return (
    <div className="checkout-embed-preview">
      {error && !activeUrl ? (
        <p className="checkout-embed-preview-error">{error}</p>
      ) : (
        <MoneyEUIframeCheckout checkoutUrl={activeUrl} onError={setError} />
      )}
    </div>
  );
};

export default CheckoutEmbedPreview;
